import { sourcesDestinationsConstants } from "../_constants";
import { sourcesDestinationsServices } from "../_services";
import { alertActions } from ".";

export const sourcesDestinationsActions = {
  getSourceDestinationsByConnectionId,
  editSourceDestinationById,
  deleteSourceDestinationById
};


function getSourceDestinationsByConnectionId(connectionId) {
  return (dispatch) => {
    dispatch(request());
    sourcesDestinationsServices.getSourceDestinationsByConnectionId(connectionId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_REQUEST };
  }
  function success(data) {
    return {
      type: sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: sourcesDestinationsConstants.GET_SOURCE_AND_DESTINATION_BY_CONNECTION_ID_FAILURE, error };
  }
}

function editSourceDestinationById(infraConfigId, formData) {
  return (dispatch) => {
    dispatch(request());
    sourcesDestinationsServices.editSourceDestinationById(infraConfigId, formData).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: sourcesDestinationsConstants.EDIT_SOURCE_AND_DESTINATION_BY_ID_FAILURE, error };
  }
}

function deleteSourceDestinationById(formData,infraConfigId) {
  return (dispatch) => {
    dispatch(request());
    sourcesDestinationsServices.deleteSourceDestinationById(formData,infraConfigId).then(
      (data) => {
        dispatch(success(data));
        dispatch(alertActions.success(data.message));
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_REQUEST };
  }
  function success(data) {
    return {
      type: sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_SUCCESS,
      data,
    };
  }
  function failure(error) {
    return { type: sourcesDestinationsConstants.DELETE_SOURCE_AND_DESTINATION_BY_ID_FAILURE, error };
  }
}


